export function FloatingBookTable() {
  const go = () => document.querySelector("#book-table")?.scrollIntoView({ behavior: "smooth" });

  return (
    <div data-testid="floating-book-table" className="fixed bottom-5 right-4 md:bottom-7 md:right-7 z-40">
      <button
        onClick={go}
        aria-label="Book a Table"
        data-testid="floating-book-table-btn"
        className="block hover:translate-x-[2px] hover:translate-y-[2px] transition-transform"
      >
        <img src="/book-pill.png" alt="Book a Table" className="h-16 md:h-[74px] w-auto" />
      </button>
    </div>
  );
}
